module.exports = __webpack_public_path__ + "img/caracteristicas-mamo.57b03233.jpg";